import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import ProductPrice from "../../components/product/ProductPrice";
import { appGetProductDetails } from "../../services/ProductService";
import { addRecentlyViewedProducts } from "../../store/actions/recentViewedProductsActions";
import RecentlyViewedProducts from "../../components/ProductDetails/RecentlyViewedProducts";
import RelatedProducts from "../../components/ProductDetails/RelatedProducts";
import {
  PERC_OFF_TEXT,
  PLEASE_WAIT_TXT,
  TOKEN_KEY,
  SIZE_OPTION_GROUP_ID
} from "../../utils/Constant";
import { appAddToCart } from "../../services/CartServices";
// import { toast } from "react-toastify";
import WishlistItem from "../../components/Wishlist/WishlistItem";
import { setOpenPoup } from "../../store/actions/popupActions";
// import { ButtonGroup, ToggleButton } from "react-bootstrap";
import Header from "../../components/Header/Header";
import ProductGallery from "../../components/ProductDetails/Images/ProductGallery";

import "./ProductDetails.css";
import MobileShare from "../../components/Common/MobileShare";
import ProductDetailsPlaceholder from "../../components/Placeholders/Templates/ProductDetailsPlaceholder";
import DesktopShare from "../../components/Common/DesktopShare";
import NotifyMe from "../../components/ProductDetails/SoldOut/NotifyMe";
import AddToCartPopup from "../../components/ProductDetails/SoldOut/AddToCartPopup";

import { useQuery } from "react-query";
import ProductOptionsMobile from "../../components/ProductDetails/ProductOptionsMobile";
import ProductOptionsDesktop from "../../components/ProductDetails/ProductOptionsDesktop";
import { useLocation, useNavigate, useParams , useSearchParams} from "react-router-dom";
import SizeGuideModal from "../../components/ProductDetails/SizeGuide/SizeGuideModal";
import { useSnackbar } from 'react-simple-snackbar';
import { isMobile } from "react-device-detect";
import { addCartCount } from "../../store/actions/cartActions";
import {productPageEventsFB, addToCartEventsFB} from "../../utils/PixelEvents/FacebookEvents";
import {GoogleProductEvents, GoogleAddToCartEvents} from "../../utils/PixelEvents/GoogleEvents";

function ProductDetails(props) {
  const dispatch = useDispatch();
  let mobileSelect2Ref = useRef(null);

  const user = useSelector((state) => state.auth?.user);

  // const breadcrumbs = [
  //   {
  //     title: "Home",
  //     link: "/",
  //   },
  // ];
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Get id of product from url
  const { id: productId } = useParams();

/**
 * BOC 
 * task #149929 Darveys:- Ads feed - Product Page URL to be updated According to the size.
 * author Maanik Arya 
 * date 22-05-24
 * use_of_code :- We have added code to retrieve the currency and size_option_id from the query parameters.
 * The size_option_id is used to display the corresponding simple product with its specific size, ensuring the correct price for that size is shown on the product page.
 * This change was made to improve the accuracy of our Google feed. We send simple products with their prices and corresponding product links in the feed.
 * We are now updating the product links to include the currency and size_option_id parameters.
 * Initially, the displayed product price differed from the simple product price. Therefore, in the feed, we sent one price, but the price seen after following the link was different. This update resolves that discrepancy by ensuring consistency between the feed price and the price displayed upon visiting the product link.
 */
 const [searchParams] = useSearchParams();
 const prod_currency = searchParams.get('currency');
 const size_option_id = searchParams.get('size_option_id');
 /**
  * EOC
  */


  // if id of product is not present in url then redirect to home page.
  if (!productId) {
    navigate("/");
  }

  const [productDetails, setProductDetails] = useState({});
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [cartProduct, setCartProduct] = useState({});
  const [sizeGuideoptionmobile, setsizeGuideoptionmobile] = useState("none");
  const [addToBagButtonDisplayStatus, setaddToBagButtonDisplayStatus] = useState("block");
  const [openAddCartPopup, setopenAddCartPopup] = useState(false);
  const [addToCartsize, setaddToCartsize] = useState("");
  const snackbar_options = {
    position: isMobile?'top-center' : '',
    style: {
      marginTop : isMobile?'45px' : ''
    }    
  }
  const [openSnackbar] = useSnackbar(snackbar_options);

  const setsizeGuideoptionmobilefunction = (value) => {
    setsizeGuideoptionmobile(value);
  };

  const setaddToBagButtonDisplayStatusfunction = (value) => {
    setaddToBagButtonDisplayStatus(value);
  };

  const [qty] = useState(1);
  // const [showProdSkeleton, setShowProdSkeleton] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [optionButtonDisable, setoptionButtonDisable] = useState(false);
  const [productPrice, setproductPrice] = useState("");
  const [productDiscountPercentage, setproductDiscountPercentage] = useState("");

  const { isLoading: showProdSkeleton, data } = useQuery(
    ["productDetails", productId],
    () =>
      appGetProductDetails({ product_url: productId }).then((res) => {
        res = JSON.parse(res?.data);
        // handling error in try catch block
        // setproductPrice(res?.product?.discount_price);
        try {
          productPageEventsFB(res);
        } catch (e) {
          console.log(e.message);
        }
        // handling error in try catch block
        try {
          GoogleProductEvents(res);
        } catch (e) {
          console.log(e.message);
        }
        return res;
      })
  );

  useEffect(() => {
    if (data?.product?.status === "failure") {
      return navigate("/");
    }

    /**
     * BOC 
     * task #149929 Darveys:- Ads feed - Product Page URL to be updated According to the size.
     * author Maanik Arya 
     * date 22-05-24
     * use_of_code :- We have added code to udpate the product price and discount percentage on the product page according to the product size using the size_option_id .
     * We are getting the size_option_id from the query parameter.
     * The size_option_id is used to display the corresponding simple product with its specific size, ensuring the correct price for that size is shown on the product page.
     * This change was made to improve the accuracy of our Google feed. We send simple products with their prices and corresponding product links in the feed.
     * We are now updating the product links to include the currency and size_option_id parameters.
     * Initially, the displayed product price differed from the simple product price. Therefore, in the feed, we sent one price, but the price seen after following the link was different. This update resolves that discrepancy by ensuring consistency between the feed price and the price displayed upon visiting the product link.
     */
    if(prod_currency && size_option_id){ 

      if(data?.product){

        let productSizeOptions = data?.product?.options; 
        let sizeOptionsObj = productSizeOptions?.find((e) => e.id === SIZE_OPTION_GROUP_ID) || {};
        let selectedProdOption = sizeOptionsObj?.items.find(item => item.id === size_option_id);
  
        console.log("testing sizeOptionsObj :- " , sizeOptionsObj  ) ; 

        const prodData = {
          ...data,
          product: {
            ...data.product,
            discount_price: selectedProdOption?.special_price,
            discount_percentage: selectedProdOption?.discount_percentage ,
          }
        };

        setproductPrice(selectedProdOption?.special_price);
        setProductDetails(prodData?.product || {}); 
      }

    }else{
      setProductDetails(data?.product || {}); 
      setRelatedProducts(data?.related_products || []);
    }
    /**
     * EOC
     */

    // add current product in recently viewed product list
    let urlPath = pathname?.replace("/product/", "");
    dispatch(
      addRecentlyViewedProducts({ ...data?.product, url_path: urlPath } || {})
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    let productAttributes = [];
    productDetails?.options?.forEach((option, i) => {
      if (option?.items && option?.items?.length === 1) {
        let item = option?.items[0] || {};
        productAttributes.push({
          qty: 0,
          value: item?.id,
          name: item?.value,
          id: option?.id,
          required: option?.required,
        });
      } else {
        productAttributes.push({
          qty: 0,
          value: "",
          id: option?.id,
          required: option?.required,
        });
      }
    });

    setCartProduct({
      giftcard_fields: "",
      product_type: productDetails.product_type,
      id_product_attribute: productAttributes,
      custom_options: productDetails.custom_options,
      quantity: 0,
      product_id: productDetails.id_product,
      minimal_quantity: productDetails.minimal_quantity,
    });
  }, [productDetails]);

  //function for handling the cache issue on the catalog page dur to this need to add here also
  const updateWishlistProductStatuscb = (product_id,wishlist_status) => {
    
  }

  const onOptionSelected = (attrId, optionId, optionValue, special_price, discount_percentage, disable_status) => {
    let newCartProduct = { ...cartProduct };
    newCartProduct.id_product_attribute.forEach((attr) => {
      if (attr.id === attrId) {
        attr.value = optionId;
        attr.name = optionValue;
      }
    });
    setproductPrice(special_price);
    setproductDiscountPercentage(discount_percentage);
    setCartProduct(newCartProduct);
    setoptionButtonDisable(disable_status);
  };

  const addToCart = () => {
    setIsSubmitting(true);
    let validCart = true;

    cartProduct?.id_product_attribute?.forEach((attr) => {
      setaddToCartsize(attr.name);
      if (attr.required === "1" && !attr.value) {
        validCart = false;
      } else {
        attr.quantity = qty;
      }
    });

    if (!validCart) {
      // toast.error("Please specify the product's option(s).");
      if(isMobile){
        window.$('#size_prod').trigger("click");        
      } else {
        openSnackbar("Please specify the product's option(s).");
      }
      setIsSubmitting(false);
      return;
    }

    cartProduct.quantity = qty;

    const cartData = {
      request_type: "add",
      voucher: "",
      user_type: "",
      email: user && user.email ? user.email : "",
      coupon: "",
      cart_products: [cartProduct],
      customization_details: [],
      session_id: localStorage.getItem(TOKEN_KEY),
    };

    /**
     * @BOC
     * @Task #160361 Implementation Of Conversion API - Phase 2
     * @author Maanik Arya
     * @date 27-05-25
     * @use_of_code: We decided to call the Add to Cart API first and then call the Google and Facebook events.
     * This is because when the Add to Cart API gives the sucess response then the add to cart event is triggered.
     * Also, we are passing the meta event_id in the API response then we will pass the event_id in the Facebook Add to Cart events.
     */
    // try {
    //   let add_to_cart_product_details = cartProduct?.id_product_attribute[0];
    //   GoogleAddToCartEvents(productDetails, add_to_cart_product_details);
    //   addToCartEventsFB(productDetails, add_to_cart_product_details);
    // } catch (e) {
    //   console.log(e.message);
    // }
    /**
     * @EOC
     */

    appAddToCart(cartData)
      .then((res) => {
        res = JSON.parse(res.data);

        if (res.status === "success") {
          // toast.success(res.message); // removed notification as per design
          if(isMobile){
            mobileSelect2Ref?.current?.hide();
            // mobileSelect2Ref.current = null;
            // mobileSelect2Ref = null;
            dispatch(addCartCount(res?.total_cart_items || 0));
            setopenAddCartPopup(true);
            setaddToBagButtonDisplayStatus("none");
          }else{
            dispatch(setOpenPoup("sidecart"));
          }


          /**
           * @BOC
           * @Task #160361 Implementation Of Conversion API - Phase 2
           * @author Maanik Arya
           * @date 27-05-25
           * @use_of_code: We decided to call the Add to Cart API first and then call the Google and Facebook events.
           * This is because when the Add to Cart API gives the sucess response then the add to cart event is triggered.
           * Also, we are passing the meta event_id in the API response then we will pass the event_id in the Facebook Add to Cart events.
           */
          try {
            let add_to_cart_product_details = cartProduct?.id_product_attribute[0];
            GoogleAddToCartEvents(productDetails, add_to_cart_product_details);
            addToCartEventsFB(productDetails, add_to_cart_product_details, res?.addtocart_event_id);
          } catch (e) {
            console.log(e.message);
          }
          /**
           * @EOC
           */


        } else {
          // toast.error(res.message);
          openSnackbar(res.message);
        }
      })
      .finally(() => setIsSubmitting(false));
  };


  const openAddCartPopupfunction = (value) =>{
    setopenAddCartPopup(value);
  }

  return (
    <>
      {/* Header */}
      <Header
        mobileHeaderOptions={{
          menuIcon: false,
          wishlistIcon: false,
          rightWishlistIcon: true,
          darveysLargeTextIcon: false,
          searchIcon: true,
          shoppingBagIcon: true,
          backButtonIcon: true,
          pageHeadingShow: true,
          pageHeadingText: productDetails?.designer_name || "",
          darveysSmallIcon: true,
          userAccountIcon: false,
        }}
      />
      <div className="clearfix"></div>

      {/* Breadcrumb Section */}
      <section className="breadcrumb-heading spacer desktop-display">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              {/* <Breadcrumb
                breadcrumbs={[
                  ...breadcrumbs,
                  { title: productDetails?.category_name || "", active: true },
                  // { title: productDetails?.name || "", active: true },
                ]}
                isLoading={showProdSkeleton}
              /> */}
              <Breadcrumb
                breadcrumbs={productDetails?.category_name || []}
                isLoading={showProdSkeleton}
              />
            </div>
          </div>
        </div>
      </section>

      <div className="clearfix"></div>

      {/* Product Main Section */}
      {showProdSkeleton ? (
        <ProductDetailsPlaceholder />
      ) : (
        <>
          <section className="products-main">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-8" style={{ position: "relative" }}>
                  <ProductGallery images={productDetails?.images || []} />

                  <WishlistItem
                    productId={productDetails?.id_product}
                    isInWishlist={productDetails?.is_in_wishlist}
                    className="mb-p-wishilist wishlist d-mbl"
                    updateWishlistProductStatuscb = {updateWishlistProductStatuscb}
                  />

                  <div className="authentication-text mt-40 d-dsk">
                    {/* <p className="text-black">Authenticated by:</p> */}
                    <img
                      src="../assets/images/authenticated-img.png"
                      alt=""
                      className="d-block img-fluid"
                      onClick={(e) => navigate("/atelier")}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="product-desc d-dsk">
                    <h1>
                      {productDetails?.designer_name || ""}
                      <p className="text-black">{productDetails?.name || ""}</p>
                    </h1>
                    <div className="price mt-30">
                      <ProductPrice
                        price={productDetails.price}
                        show_price={
                          productDetails.show_price?.toString() === "1"
                        }
                        discount_price={productPrice ? productPrice : productDetails.discount_price}
                        discount_perc={productDiscountPercentage? (productDiscountPercentage > 0 ? productDiscountPercentage : "") : productDetails.discount_percentage}
                        show_discount_price={
                          productDetails.show_discount_price?.toString() === "1"
                        }
                        show_discount_perc={
                          productDetails.show_discount_percentage?.toString() ===
                          "1"
                        }
                        perc_text={PERC_OFF_TEXT}
                        show_brackets={true}
                      />
                      <span className="text-grey">
                        {productDetails?.product_info?.find(
                          (info) => info?.name === "EMI Details"
                        )?.value || ""}
                      </span>
                    </div>

                    <ProductOptionsDesktop
                      productId={productDetails.id_product}
                      isSizeGuideAvailable={
                        productDetails?.is_size_guide_available?.toString() ===
                        "1"
                      }
                      showSizeMapping={
                        productDetails?.size_mapping_module?.toString() ===
                        "1"
                      }
                      productOptions={productDetails?.options}
                      onOptionSelectedCb={onOptionSelected}
                    />

                    <div className="add-to-cart-btn mt-20">
                      {productDetails?.available_for_order === "1" && (
                        <button
                          className="btn-primary"
                          onClick={addToCart}
                          disabled={isSubmitting}
                          id="cart_drop"
                        >
                          {isSubmitting ? PLEASE_WAIT_TXT : "ADD TO BAG"}
                        </button>
                      )}

                      <WishlistItem
                        productId={productDetails?.id_product}
                        isInWishlist={productDetails?.is_in_wishlist}
                        className="wishlist"
                        updateWishlistProductStatuscb = {updateWishlistProductStatuscb}
                      />
                    </div>
                    <div className="accordion mt-30" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <b>Description</b>
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body"
                            dangerouslySetInnerHTML={{
                              __html: productDetails?.description || "",
                            }}
                          >
                            {/* <p>{productDetails?.description || ""}</p> */}
                          </div>
                        </div>
                      </div>

                      {productDetails?.product_additional_info?.map(
                        (addInfo, index) => {
                          return (
                            <div className="accordion-item" key={index}>
                              <h2
                                className="accordion-header"
                                id={"heading" + index}
                              >
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={"#collapse" + index}
                                  aria-expanded="false"
                                  aria-controls={"collapse" + index}
                                >
                                  <b>{addInfo?.name}</b>
                                </button>
                              </h2>
                              <div
                                id={"collapse" + index}
                                className="accordion-collapse collapse"
                                aria-labelledby={"heading" + index}
                                data-bs-parent="#accordionExample"
                              >
                                <div
                                  className="accordion-body"
                                  dangerouslySetInnerHTML={{
                                    __html: addInfo?.value,
                                  }}
                                >
                                  {/* {addInfo?.value} */}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <DesktopShare
                      {...{
                        title: productDetails.designer_name || "",
                        description: productDetails.name || "",
                        imageUrl: productDetails?.images
                          ? productDetails?.images[0]?.src
                          : "" || "",
                        url: window.location.href,
                      }}
                    />
                  </div>
                </div>

                <div className="col-12 p-0">
                  <section className="product-name bg-mobile-light text-center d-mbl">
                    <div className="container-fluid">
                      <div className="row">
                          <h1 className="text-black">
                            {productDetails?.designer_name || ""}
                            <p className="desc-text">
                              {productDetails?.name || ""}
                            </p>
                          </h1>
                        <ProductPrice
                          price={productDetails.price}
                          show_price={
                            productDetails.show_price?.toString() === "1"
                          }
                          discount_price={productPrice ? productPrice : productDetails.discount_price}
                          discount_perc={productDiscountPercentage? (productDiscountPercentage > 0 ? productDiscountPercentage : "") : productDetails.discount_percentage}
                          show_discount_price={
                            productDetails.show_discount_price?.toString() ===
                            "1"
                          }
                          show_discount_perc={
                            productDetails.show_discount_percentage?.toString() ===
                            "1"
                          }
                          perc_text={PERC_OFF_TEXT}
                          show_brackets={true}
                        />

                        <span className="text-black incl-text">
                          {productDetails?.product_info?.find(
                            (info) => info?.name === "EMI Details"
                          )?.value || ""}
                        </span>
                        <MobileShare
                          url={window.location.href}
                          title={productDetails?.name || ""}
                          text={productDetails?.name || ""}
                        />
                      </div>
                    </div>
                  </section>
                </div>

                <div className="col-12">
                  {/* <!-- PRODUCTS-MAIN STARTS --> */}
                  <section className="products-main mt-20 d-mbl">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="product-desc">
                            {/* Cusotm Option Starts */}
                            <ProductOptionsMobile
                              productOptions={productDetails?.options}
                              onOptionSelectedCb={onOptionSelected}
                              mobileSelect2Ref={mobileSelect2Ref}
                              setsizeGuideoptionmobilefunction={
                                setsizeGuideoptionmobilefunction
                              }
                            />
                            {/* Cusotm Option Ends */}

                            {/* Accordion Description Starts */}
                            <div
                              className="accordion mt-30"
                              id="accordionExampleMob"
                            >
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id="headingOneMob"
                                >
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOneMob"
                                    aria-expanded="true"
                                    aria-controls="collapseOneMob"
                                  >
                                    <b>Description</b>
                                  </button>
                                </h2>
                                <div
                                  id="collapseOneMob"
                                  className="accordion-collapse collapse show"
                                  aria-labelledby="headingOneMob"
                                  data-bs-parent="#accordionExampleMob"
                                >
                                  <div className="accordion-body"
                                    dangerouslySetInnerHTML={{
                                      __html: productDetails?.description || "",
                                    }}
                                  >
                                    {/* <p>{productDetails?.description || ""}</p> */}
                                  </div>
                                </div>
                              </div>

                              {productDetails?.product_additional_info?.map(
                                (addInfo, index) => {
                                  return (
                                    <div className="accordion-item" key={index}>
                                      <h2
                                        className="accordion-header"
                                        id={"headingMob" + index}
                                      >
                                        <button
                                          className="accordion-button collapsed"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target={
                                            "#collapseMob" + index
                                          }
                                          aria-expanded="false"
                                          aria-controls={"collapseMob" + index}
                                        >
                                          <b>{addInfo?.name}</b>
                                        </button>
                                      </h2>
                                      <div
                                        id={"collapseMob" + index}
                                        className="accordion-collapse collapse"
                                        aria-labelledby={"headingMob" + index}
                                        data-bs-parent="#accordionExampleMob"
                                      >
                                        <div
                                          className="accordion-body"
                                          dangerouslySetInnerHTML={{
                                            __html: addInfo?.value,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                            {/* Accordion Description Ends */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <!-- PRODUCTS-MAIN ENDS --> */}

                  <div className="clearfix"></div>

                  {/* <!-- AUTHENTICATED BY STARTS --> */}
                  <section className="authenticated-by spacer d-mbl">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-12">
                          {/* <h5 className="text-black text-center">
                            Authenticated By:
                          </h5> */}
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/Authenticated-by.png"
                            }
                            className="img-fluid mx-auto d-block mt-25"
                            alt=""
                            onClick={(e) => navigate("/atelier")}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <!-- AUTHENTICATED BY ENDS --> */}
                </div>
              </div>
            </div>

            {/* Notify Me */}
            {productDetails?.available_for_order === "0" && (
              <NotifyMe productId={productId} />
            )}
            {openAddCartPopup && (
              <AddToCartPopup
                productDetails={productDetails}
                openAddCartPopupfunction={openAddCartPopupfunction}
                addToCartsize={addToCartsize}
                setaddToBagButtonDisplayStatusfunction={
                  setaddToBagButtonDisplayStatusfunction
                }
                addToCartSpecialPrice={productPrice}
              />
            )}

            {/* Add To Cart Action Buttons Start */}
            {productDetails?.available_for_order === "1" && (
              <div className="add-to-cart-btn mt-20 d-mbl m-add-to-cart-btn">
                {productDetails?.is_size_guide_available?.toString() ===
                  "1" && (
                  <div
                    className="sizeGuideoption"
                    style={{
                      marginBottom: "20px",
                      float: "left",
                      display: sizeGuideoptionmobile,
                      width: "100%",
                    }}
                  >
                    <SizeGuideModal
                      productId={productDetails?.id_product}
                      mobileSelect2Ref={mobileSelect2Ref}
                      setaddToBagButtonDisplayStatusfunction={setaddToBagButtonDisplayStatusfunction}
                    />
                  </div>
                )}
                <button
                  className="btn-primary btn-fw"
                  onClick={addToCart}
                  id="cart_drop"
                  disabled={isSubmitting || optionButtonDisable}
                  style={{
                    display: addToBagButtonDisplayStatus
                  }}
                >
                  {isSubmitting ? PLEASE_WAIT_TXT : "ADD TO BAG"}
                </button>
              </div>
            )}
            {/* Add To Cart Action Buttons End */}
          </section>

          <div className="clearfix"></div>

          {/* Recently Viewed Products Section */}
          <RecentlyViewedProducts />

          <div className="clearfix"></div>

          {/* Related Products Section */}
          <RelatedProducts relatedProducts={relatedProducts || []} />
        </>
      )}
    </>
  );
}

export default ProductDetails;
